import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAddProductLimitRequest } from '../models/models'

export class AddProductLimitApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productLimit/add-limit',
      requesterInfo,
    })
  }

  public async addProductLimit(request: IAddProductLimitRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
